// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"79af931b","234":"16ae1bd8","353":"4289b50f"}[chunkId] + ".js";
};